import * as React from "react";
import './App.scss';
import Routing from "./routing/Routing";

class App extends React.Component {

    public render() {
        return <Routing/>
    }

}

export default App;

